import { render, staticRenderFns } from "./PdpAntiTippingBanner.vue?vue&type=template&id=211d9b73&"
import script from "./PdpAntiTippingBanner.vue?vue&type=script&lang=js&"
export * from "./PdpAntiTippingBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default})
